const routes = [
	{name: "home", path: "/"},
	{name: "about", path: "/info"},
	{name: "work", path: "/work", children: [
		{name: "view", path: "/:id"}
	]}
];

export default routes